module.exports = __webpack_public_path__ + "img/logo.2ea78089.png";